import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib_app/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSessionUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        localStorage.setItem("sp_token", data.token);
        setSessionUser(data.user);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard");
        toast.success(`Selamat datang, ${data.user.name}`);
      } catch (err) {
        toast.error("Gagal login dengan Google");
        navigate("/login");
      }
    })();
  }, [navigate, setSessionUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F7F8]">
      <div className="text-zinc-500 text-sm">Memverifikasi sesi...</div>
    </div>
  );
}
